import { render, staticRenderFns } from "./MessageRoleConfig.vue?vue&type=template&id=cf0b5484"
import script from "./MessageRoleConfig.vue?vue&type=script&lang=js"
export * from "./MessageRoleConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports